/**
 * Reduced motion (idc-portal-design v1.1, Motion rule 8). CSS removes every animation and transition under
 * prefers-reduced-motion (styles/ipd.css); this hook is for the JS side: choreography-only waits and classes
 * (the sign-in entrance) are skipped, and the aurora's Pause control isn't rendered.
 */
import { useEffect, useState } from "react";

const QUERY = "(prefers-reduced-motion: reduce)";

function mediaReduced(): boolean {
  return typeof window !== "undefined" && typeof window.matchMedia === "function" && window.matchMedia(QUERY).matches;
}

/** True when the OS asks for reduced motion, or the app root carries data-motion="reduce" (a user preference). */
export function prefersReducedMotion(): boolean {
  if (mediaReduced()) return true;
  if (typeof document === "undefined") return false;
  return document.documentElement.getAttribute("data-motion") === "reduce" || document.querySelector(".ipd-app")?.getAttribute("data-motion") === "reduce";
}

export function useReducedMotion(): boolean {
  const [reduced, setReduced] = useState(prefersReducedMotion);
  useEffect(() => {
    if (typeof window.matchMedia !== "function") return;
    const mq = window.matchMedia(QUERY);
    const on = () => setReduced(prefersReducedMotion());
    mq.addEventListener?.("change", on);
    return () => mq.removeEventListener?.("change", on);
  }, []);
  return reduced;
}
